export default __webpack_public_path__ + "static/media/react.eb0f58cf.png";